/* T-POWER Workshop theme — small progressive enhancements */
(function () {
  'use strict';

  /* Mobile menu */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    var menu = document.getElementById(btn.getAttribute('aria-controls'));
    if (!menu) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
    });
  });

  /* Predictive search: type a model or part number, see matches */
  var money = function (cents) {
    var fmt = (window.TPOWER && window.TPOWER.moneyFormat) || '${{amount}}';
    var amount = (Number(cents) / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount);
  };
  var escapeHtml = function (s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  document.querySelectorAll('[data-predictive]').forEach(function (form) {
    var input = form.querySelector('input[type="search"]');
    var box = form.querySelector('.predictive');
    if (!input || !box) return;
    var timer, controller, active = -1;
    var hideTag = (window.TPOWER && window.TPOWER.hideTag) || '';

    function close() { box.classList.remove('is-open'); input.setAttribute('aria-expanded', 'false'); active = -1; }
    function render(products, q) {
      if (!products.length) {
        box.innerHTML = '<a class="predictive__all" href="' + form.action + '?q=' + encodeURIComponent(q) + '">No quick match. See all results for “' + escapeHtml(q) + '”</a>';
      } else {
        box.innerHTML = products.map(function (p, i) {
          var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=96" alt="" loading="lazy">' : '<span class="cat__icon" style="width:44px;height:44px"></span>';
          return '<a role="option" id="pred-' + i + '" href="' + p.url + '">' + img +
            '<span class="predictive__title">' + escapeHtml(p.title) + '</span>' +
            '<span class="predictive__price">' + money(p.price) + '</span></a>';
        }).join('') + '<a class="predictive__all" href="' + form.action + '?q=' + encodeURIComponent(q) + '&type=product">See all results →</a>';
      }
      box.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = 'AbortController' in window ? new AbortController() : null;
        var url = (window.TPOWER && window.TPOWER.predictiveUrl || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag,body';
        fetch(url, controller ? { signal: controller.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var list = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (hideTag) list = list.filter(function (p) { return !(p.tags || []).includes(hideTag); });
            render(list.slice(0, 6), q);
          })
          .catch(function () {});
      }, 180);
    });
    input.addEventListener('keydown', function (e) {
      var items = box.querySelectorAll('a');
      if (!box.classList.contains('is-open') || !items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = e.key === 'ArrowDown' ? Math.min(active + 1, items.length - 1) : Math.max(active - 1, 0);
        items.forEach(function (a, i) { a.setAttribute('aria-selected', String(i === active)); });
        items[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && active > -1) {
        e.preventDefault();
        window.location.href = items[active].href;
      } else if (e.key === 'Escape') {
        close();
      }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  });

  /* Product gallery thumbnails */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('.js-gallery-main');
    if (!main) return;
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-src');
        main.srcset = t.getAttribute('data-srcset') || '';
        main.alt = t.getAttribute('data-alt') || '';
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  });

  /* Quantity buttons */
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v = b.dataset.step === 'up' ? v + 1 : Math.max(1, v - 1);
        input.value = v;
      });
    });
  });

  /* Variant picker (only when a product has more than one variant) */
  document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
    var form = sel.closest('form');
    var dataEl = document.getElementById(sel.dataset.variantsId);
    if (!form || !dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var priceEl = document.querySelector('[data-product-price]');
    var btn = form.querySelector('[type="submit"]');
    sel.addEventListener('change', function () {
      var v = variants.find(function (x) { return String(x.id) === sel.value; });
      if (!v) return;
      if (priceEl) priceEl.textContent = money(v.price);
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.dataset.addText : btn.dataset.soldText;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  });
})();

/* Load "Customers also bought" after the page */
(function () {
  var el = document.querySelector('[data-recommendations]');
  if (!el || el.children.length) return;
  fetch(el.dataset.url)
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    })
    .catch(function () {});
})();
